import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs';
import { catchError, map, mergeMap, shareReplay, switchMap } from 'rxjs/operators';
import * as mainActions from '../main/main.actions';
import { Action } from '@ngrx/store';
import { SoledadSearchService } from '../../../shared/services/b2b/search.service';
import { SoledadBannerService } from '../../../shared/services/b2b/banner.service';
import { SoledadUserService } from '../../../shared/services/b2b/user.service';
import { of } from 'rxjs';

@Injectable()
export class MainEffects {
    constructor(
        private actions$: Actions,
        private searchService: SoledadSearchService,
        private bannerService: SoledadBannerService,
        private userService: SoledadUserService
    ) {}

    getBrands$: Observable<Action> = createEffect(() =>
        this.actions$.pipe(
            ofType(mainActions.MainActionTypes.DO_GET_BRANDS),
            mergeMap((action: mainActions.DoGetBrands) =>
                this.searchService.getBrands(action.payload.type).pipe(
                    map((response) => new mainActions.DoGetBrandsOK(response)),
                    catchError((error) => of(new mainActions.DoGetBrandsKO(error)))
                )
            )
        )
    );

    getAllBrands$: Observable<Action> = createEffect(() =>
        this.actions$.pipe(
            ofType(mainActions.MainActionTypes.DO_GET_ALLBRANDS),
            mergeMap((action: mainActions.DoGetAllBrands) =>
                this.searchService.getBrands(action.payload.type).pipe(
                    map((response) => new mainActions.DoGetAllBrandsOK(response)),
                    catchError((error) => of(new mainActions.DoGetAllBrandsKO(error)))
                )
            )
        )
    );

    getReplacementOrders$: Observable<Action> = createEffect(() =>
        this.actions$.pipe(
            ofType(mainActions.MainActionTypes.DO_GET_REPLACEMENTORDERS),
            switchMap((action: mainActions.DoGetAllReplacementOrders) =>
                this.userService.getReplacementOrders(action.payload).pipe(
                    map((response) => new mainActions.DoGetAllReplacementOrdersOK(response)),
                    catchError((error) => of(new mainActions.DoGetAllReplacementOrdersKO(error)))
                )
            )
        )
    );

    getFeatureOptions$: Observable<Action> = createEffect(() =>
        this.actions$.pipe(
            ofType(mainActions.MainActionTypes.DO_GET_FEATURE_OPTIONS),
            mergeMap((action: mainActions.DoGetFeatureOptions) =>
                this.searchService
                    .getFeatureOptions(action.payload.type, action.payload.feature, action.payload.searchParams)
                    .pipe(
                        map(
                            (response) =>
                                new mainActions.DoGetFeatureOptionsOK({
                                    type: action.payload.type,
                                    feature: action.payload.feature,
                                    response: response,
                                })
                        ),
                        catchError((error) => of(new mainActions.DoGetFeatureOptionsKO(error)))
                    )
            )
        )
    );

    getFeatureChecks$: Observable<Action> = createEffect(() =>
        this.actions$.pipe(
            ofType(mainActions.MainActionTypes.DO_GET_FEATURE_CHECKS),
            mergeMap((action: mainActions.DoGetFeatureChecks) =>
                this.searchService.getFeatureChecks(action.payload.type, action.payload.searchParams).pipe(
                    map(
                        (searchFeatureChecks) =>
                            new mainActions.DoGetFeatureChecksOK({
                                searchFeatureChecks,
                            })
                    ),
                    catchError((error) => of(new mainActions.DoGetFeatureChecksKO(error)))
                )
            )
        )
    );

    getBanners$: Observable<Action> = createEffect(() =>
        this.actions$.pipe(
            ofType(mainActions.MainActionTypes.DO_GET_BANNERS),
            switchMap((action: mainActions.DoGetBanners) =>
                this.bannerService.getBanners(action.payload.selectedAddress, action.payload.searchType).pipe(
                    map((response) => new mainActions.DoGetBannersOK(response)),
                    catchError((error) => of(new mainActions.DoGetBannersKO(error)))
                )
            )
        )
    );

    setMenuItem$: Observable<Action> = createEffect(() =>
        this.actions$.pipe(
            ofType(mainActions.MainActionTypes.DO_SET_MENU_ITEM),
            switchMap((action: mainActions.DoSetMenuItem) => [new mainActions.DoResetFeatureChecks()])
        )
    );
}
